// extracted by mini-css-extract-plugin
export var baseWrapper = "Layout-module--baseWrapper--f1nje";
export var navBox = "Layout-module--navBox--XfeS4";
export var navBoxIsOpen = "Layout-module--navBoxIsOpen--2E3tA";
export var toggleButtonBox = "Layout-module--toggleButtonBox--oSKS7";
export var openButtonBoxBlack = "Layout-module--openButtonBoxBlack--4e++o";
export var mainBox = "Layout-module--mainBox--lZrF3";